import { Alert, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, IconButton } from '@mui/material';
import { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';
import { Close, InfoOutlined } from '@mui/icons-material';

export default class TerminationDeleteConfirmationModal extends Component
{
    state = {
        excludeFromCensus: false
    }
    render()
    {
        const { action, onCancel, loading } = this.props;

        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={true}
                onClose={onCancel}
            >
                <DialogTitle id="delete-term-user" sx={{ m: 0, p: 2 }}>
                    Remove user from term list?
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onCancel}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: 'black.900'
                    }}
                >
                    <Close />
                </IconButton>
                <DialogContent style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                    <DialogContentText id="alert-dialog-description" style={{ marginTop: -20, fontSize: 12 }}>
                        This action will remove the borrower from the termination list. This will allow the borrower to continue to use the PeopleJoy services. We will also email the user to communicate this was in error
                    </DialogContentText>

                    <DialogContentText>
                        <Alert variant='filled' severity="warning" sx={{
                            backgroundColor: '#FFCC80', // light orange
                            color: '#663C00', // dark text for contrast
                            fontSize: 12
                        }} icon={<InfoOutlined color='warning' />} >
                            Please confirm that this user is on the Census file before removing. Otherwise, they will be flagged for removal when the next census file is processed
                        </Alert>
                    </DialogContentText>

                    <DialogContentText>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    disabled={this.props.loading}
                                    checked={this.state.excludeFromCensus}
                                    onChange={(e) => this.setState({ excludeFromCensus: e.target.checked })}
                                />
                            }
                            label="Exclude employee from future Census file processing?"
                        />
                    </DialogContentText>

                    <DialogContentText id="alert-dialog-description" style={{ fontSize: 12 }}>
                        Do you want to continue and remove the user from the list?
                    </DialogContentText>

                </DialogContent>
                <Divider />

                <DialogActions style={{ justifyContent: 'space-between', padding: 20 }}>

                    <Button onClick={onCancel} variant="outlined" color="warning">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => action(this.state.excludeFromCensus)}
                        color="primary"
                        autoFocus
                        disabled={loading}
                    >
                        Continue
                    </Button>
                </DialogActions>

            </Dialog>
        )
    }
}
